import React from 'react'
import { makeStyles } from '@material-ui/core/styles';


import Atas from '../Header/Header'
import Menupilihan from '../Menupilihan/index'
// import ScrollToTop from '../ScrollToTop/ScrollToTop';


const dashboard = () => {
    const debb = makeStyles((theme)=>({
        root: {
            minHeight: '100vh',    
        }
      
    }));
    const classes = debb();

    return (
        <div>
            <div className={classes.root}>
                {/* <CssBaseline /> */}
                <Atas />
                <Menupilihan />
             </div>  
            
             {/* <div style={{display:'flex', float:'right'}}>
                 <ScrollToTop />   
             </div>
             */}
            
            
        </div>
    )
}

export default dashboard
